import React, { Component } from 'react';
import { HashAnchor } from './components/atoms';
import {
	QrHeaderView,
	QrHeroView,
	QrAboutView,
	QrVideoView,
	WorkplaceChallengesView,
	BrotherCollaborationView,
	HowQrWorksView,
	JoinQrView,
	HubFooterView,
	GetInTouchQrView,
	ContactUsQrView,
} from './components/views';

const SUPPORTS_INTERSECTION_OBSERVER =
	typeof IntersectionObserver !== 'undefined';
const THRESHOLD = 0.95;

class TaggisQrLanding extends Component {
	state = {
		showOpaqueHeader: false,
	};

	componentDidMount() {
		window.scrollTo(0, 0);
		this.setupIntersectionObserver();
	}

	componentWillUnmount() {
		this.io.disconnect();
	}

	handleThresholdMatch(entries) {
		const [{ intersectionRatio }] = entries;
		this.setState({
			showOpaqueHeader: intersectionRatio <= THRESHOLD,
		});
	}

	heroRef = React.createRef();

	setupIntersectionObserver = async () => {
		if (!SUPPORTS_INTERSECTION_OBSERVER) {
			await import('intersection-observer');
		}
		this.io = new IntersectionObserver(
			this.handleThresholdMatch.bind(this),
			{
				threshold: [THRESHOLD],
			}
		);
		this.io.observe(this.heroRef.current);
	};

	render () {
		return (
			<main>
				<QrHeaderView opaque={this.state.showOpaqueHeader} />
				<QrHeroView forwardedRef={this.heroRef} />
				<QrAboutView />
				<QrVideoView />
				<WorkplaceChallengesView />
				<HowQrWorksView />
				<JoinQrView />
				<BrotherCollaborationView />
				<HashAnchor id='contact' />
				<GetInTouchQrView />
				<ContactUsQrView />
				<HubFooterView />
			</main>
		);
	}
}

export default TaggisQrLanding;



// WEBPACK FOOTER //
// ./src/TaggisQrLanding.js